import React from 'react';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import ActivationErrorContent from '../Components/AccountActivationError/ActivationErrorContent';
import $ from 'jquery';

export default function About() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/ConfirmationError',
    title: 'Account Activation',
  });

  return (
    <React.Fragment>
      <CommonHeader />
      <ActivationErrorContent />
    </React.Fragment>
  );
}
